import React, { useState } from "react"
import { Col } from "reactstrap"

const StatusFilter = ({ setStatusFilter, options, selectedDefaultValue }) => {
  //
  const handleSelectStatus = ele => {
    const selectedValue = ele.value
    setStatusFilter(selectedValue)
  }

  return (
    <React.Fragment>
      <Col xxl={2} lg={6}>
        <select
          className="form-control select2 mb-3 mb-xxl-0"
          defaultValue={selectedDefaultValue}
          onChange={e => handleSelectStatus(e.target)}
        >
          <option disabled>Status</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </Col>
      {/* <Col xxl={2} lg={4}>
                <div className='mb-3 mb-xxl-0'>
                    <button type="button" className="btn btn-soft-secondary w-100">
                        <i className="mdi mdi-filter-outline align-middle"></i> Filter</button>
                </div>
            </Col> */}
    </React.Fragment>
  )
}
export default StatusFilter
